import { Map, List } from 'immutable';

const messages = {
  timeDiff: {
    singular: true,
    message() {
      return ({
        action: f => f,
        type: 'info',
        icon: 'fa fa-exclamation-circle',
        showClear: false,
        body: 'Your time clock\'s time or timezone is incorrect.  ' +
        'Please make sure your timezone is correct in the time clock\'s settings.',
      });
    },
  },
  clockinsPending: {
    singular: true,
    message(numPending) {
      return ({
        action: f => f, // no-op
        type: 'error',
        icon: 'fa fa-exclamation-circle',
        showClear: false,
        body: `Clock ins could not be sent. ${numPending} pending clock ` +
        `in${numPending === 1 ? '' : 's'} will be sent to Tanda when possible.`,
      });
    },
  },
  noNetwork: {
    singular: true,
    message() {
      return ({
        action: f => f,
        type: 'error',
        icon: 'fa fa-exclamation-circle',
        showClear: false,
        body: 'This time clock cannot connect to the internet. Please check the connection.',
      });
    },
  },
  deviceError: {
    singular: false,
    message() {
      return ({
        action: f => f, // no-op
        type: 'error',
        icon: 'fa fa-exclamation-circle',
        showClear: true,
        body: 'Time Clock Registration problem. Clock ins will not sync until this problem is' +
        ' resolved. Go to \'Edit Device Details\' in the Manager Settings to fix.',
      });
    },
  },
  authError: {
    singular: true,
    message() {
      return ({
        action: f => f, // no-op
        type: 'error',
        icon: 'fa fa-exclamation-circle',
        showClear: true,
        body: 'Authentication problem. Clock ins will not sync until this problem is resolved. '
        + 'Go to \'Reauthenticate\' in the Manager Settings to fix.',
      });
    },
  },
  billingError: {
    singular: true,
    message() {
      return ({
        action: f => f, // no-op
        type: 'error',
        icon: 'fa fa-exclamation-circle',
        showClear: true,
        body: 'Account Error.  Please let a manager know. '
        + 'Clock ins will not sync until this problem is resolved.',
      });
    },
  },
  forbiddenError: {
    singular: true,
    message() {
      return ({
        action: f => f, // no-op
        type: 'error',
        icon: 'fa fa-exclamation-circle',
        showClear: true,
        body: 'Access Error.  Clock ins will not sync until this problem is resolved.  '
        + 'Please \'Reauthenticate\' under Manager Settings or contact Tanda Support.',
      });
    },
  },
  systemTip: {
    singular: false,
    message(body) {
      return ({
        action: f => f, // no-op
        type: 'info',
        icon: 'fa fa-info-circle',
        showClear: true,
        body,
      });
    },
  },
  apiUserError: {
    singular: true,
    message() {
      return ({
        action: f => f,
        type: 'error',
        icon: 'fa fa-exclamation-triangle',
        body: 'The user who authenticated this time clock is no longer active.  Please' +
        ' reauthenticate your time clock.',
      });
    },
  },
  updateReady: {
    singular: true,
    message() {
      return ({
        action() { window.location.reload(); },
        type: 'info',
        icon: 'fa fa-info-circle',
        body: 'An update is available.  Tap here to reload.',
      });
    },
  },
};

export function retrieveDetails({ type, args }) {
  const t = messages[type];
  if (!t) {
    return null;
  }
  return t.message.apply(null, args);
}

export function add(state, { type, args }) {
  if (!messages[type]) {
    throw new Error('That message does not exist');
  }
  const updatedArgs = ((a) => {
    if (a instanceof List) {
      return a;
    }
    if (a instanceof Array) {
      return new List(a);
    }
    return new List([a]);
  })(args);

  const isSingular = messages[type].singular;
  const newMessage = { type };

  if (args) {
    newMessage.args = updatedArgs;
  }

  if (!isSingular) {
    return state.push(new Map(newMessage));
  }

  // need to validate that none of that message are in the list before pushing
  return state.filterNot(m => m.get('type') === newMessage.type).push(new Map(newMessage));
}

export function remove(state, index) {
  return state.delete(index);
}

export function removeByType(state, type) {
  return state.filterNot(m => m.get('type') === type);
}

export function clearMessages(state) {
  return state.clear();
}



// WEBPACK FOOTER //
// ./src/store/messages/systemMessages/lib.js